module.exports = __webpack_public_path__ + "img/eyes2.15acf3c4.svg";